class DFPForm {
    constructor() {
        this.id = 0
        this.caption = ""
        this.description = null
        this.fields = []
    }
}

class Field {
    constructor() {
        this.id = 0
        this.fe_id = 0
        this.te_id = 0
        this.td_id = 0
        this.caption = ""
        this.placeholder = ""
        this.regex = ""
        this.default_value = ""
        this.required = true
        this.orden = 1
        this.maxlength = 50
        this.ws = ""
        this.fd_id = 0
        this.ws_params = ""
        this.values = []
    }
}

class Encabezado {
    constructor() {
        this.id = 0
        this.caption = ""
        this.description = ""
        this.fields = []
    }
}

class FieldType {
    constructor() {
        this.id = 0
        this.caption = ""
        this.description = ""
        this.inputs = []
    }
}

class InputModel {
    constructor() {
        this.id = 0
        this.id_fk = 0
        this.caption = ""
        this.regex = ""
        this.html = ""
        this.ws = ""
        this.ws_params = ""
    }
}

class ListOption {
    constructor() {
        this.id = 0
        this.id_fk = 0
        this.caption = ""
        this.orden = 0
    }
}


export {
    DFPForm,
    Field,
    Encabezado,
    FieldType,
    InputModel,
    ListOption
}